import { useState, useEffect  } from "react";
import { useAuth } from "../contexts/AuthContext";
import axios from "axios";

export default function Me() {
  let { currentUser, getToken } = useAuth();

  useEffect(() => {
    async function init() {
      if (currentUser) {
        const token = await getToken();

        axios.get("https://us-central1-art-generator-5a6dd.cloudfunctions.net/api/user/me", {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }).then(response => {
          alert(JSON.stringify(response.data));
        }).catch(error => {
          alert(error)
        });
      }
    }

    init();
  }, []);

  return (
    <div className="w-full h-screen">
    </div>
  );
}